"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssertionDefinitionLifecycleSchema = exports.AssertionDefinitionLifecycle = exports.FindingContinuityDispositionSchema = exports.FindingContinuityDisposition = exports.FindingLinkOriginSchema = exports.FindingLinkOrigin = exports.ConfigScopeSchema = exports.ConfigScope = exports.LogEntryAuthorRoleSchema = exports.LogEntryAuthorRole = exports.LogEntryTypeSchema = exports.LogEntryType = exports.ContinuityKeyTypeSchema = exports.ContinuityKeyType = exports.RequirementWorkflowStateSchema = exports.RequirementWorkflowState = exports.NON_ACTIONABLE_REQUIREMENT_SEVERITIES = exports.ACTIONABLE_REQUIREMENT_SEVERITIES = exports.RequirementSeveritySchema = exports.RequirementSeverity = void 0;
const zod_1 = require("zod");
var RequirementSeverity;
(function (RequirementSeverity) {
    RequirementSeverity[RequirementSeverity["NotApplicable"] = 100] = "NotApplicable";
    RequirementSeverity[RequirementSeverity["Pending"] = 200] = "Pending";
    RequirementSeverity[RequirementSeverity["Pass"] = 300] = "Pass";
    RequirementSeverity[RequirementSeverity["Recommendation"] = 400] = "Recommendation";
    RequirementSeverity[RequirementSeverity["Indeterminate"] = 500] = "Indeterminate";
    RequirementSeverity[RequirementSeverity["Warning"] = 600] = "Warning";
    RequirementSeverity[RequirementSeverity["Fail"] = 700] = "Fail";
})(RequirementSeverity || (exports.RequirementSeverity = RequirementSeverity = {}));
exports.RequirementSeveritySchema = zod_1.z.nativeEnum(RequirementSeverity);
exports.ACTIONABLE_REQUIREMENT_SEVERITIES = [
    RequirementSeverity.Recommendation,
    RequirementSeverity.Warning,
    RequirementSeverity.Fail,
];
exports.NON_ACTIONABLE_REQUIREMENT_SEVERITIES = [
    RequirementSeverity.NotApplicable,
    RequirementSeverity.Pending,
    RequirementSeverity.Pass,
    RequirementSeverity.Indeterminate,
];
var RequirementWorkflowState;
(function (RequirementWorkflowState) {
    RequirementWorkflowState[RequirementWorkflowState["Pending"] = 100] = "Pending";
    RequirementWorkflowState[RequirementWorkflowState["Unreviewed"] = 200] = "Unreviewed";
    RequirementWorkflowState[RequirementWorkflowState["Acknowledged"] = 300] = "Acknowledged";
    RequirementWorkflowState[RequirementWorkflowState["Ignored"] = 400] = "Ignored";
    RequirementWorkflowState[RequirementWorkflowState["Fixed"] = 500] = "Fixed";
})(RequirementWorkflowState || (exports.RequirementWorkflowState = RequirementWorkflowState = {}));
exports.RequirementWorkflowStateSchema = zod_1.z.nativeEnum(RequirementWorkflowState);
var ContinuityKeyType;
(function (ContinuityKeyType) {
    ContinuityKeyType[ContinuityKeyType["Net"] = 100] = "Net";
    ContinuityKeyType[ContinuityKeyType["Module"] = 200] = "Module";
    ContinuityKeyType[ContinuityKeyType["ModuleNet"] = 300] = "ModuleNet";
    ContinuityKeyType[ContinuityKeyType["Schematic"] = 400] = "Schematic";
    ContinuityKeyType[ContinuityKeyType["Design"] = 500] = "Design";
    ContinuityKeyType[ContinuityKeyType["Custom"] = 600] = "Custom";
    ContinuityKeyType[ContinuityKeyType["NetConn"] = 700] = "NetConn";
})(ContinuityKeyType || (exports.ContinuityKeyType = ContinuityKeyType = {}));
exports.ContinuityKeyTypeSchema = zod_1.z.nativeEnum(ContinuityKeyType);
var LogEntryType;
(function (LogEntryType) {
    LogEntryType[LogEntryType["Update"] = 100] = "Update";
    LogEntryType[LogEntryType["Note"] = 200] = "Note";
    LogEntryType[LogEntryType["DeterministicValidationResult"] = 300] = "DeterministicValidationResult";
    LogEntryType[LogEntryType["AiValidationResult"] = 400] = "AiValidationResult";
    LogEntryType[LogEntryType["Continuity"] = 500] = "Continuity";
    LogEntryType[LogEntryType["Initialization"] = 600] = "Initialization";
})(LogEntryType || (exports.LogEntryType = LogEntryType = {}));
exports.LogEntryTypeSchema = zod_1.z.nativeEnum(LogEntryType);
var LogEntryAuthorRole;
(function (LogEntryAuthorRole) {
    LogEntryAuthorRole[LogEntryAuthorRole["System"] = 100] = "System";
    LogEntryAuthorRole[LogEntryAuthorRole["Admin"] = 200] = "Admin";
    LogEntryAuthorRole[LogEntryAuthorRole["User"] = 300] = "User";
})(LogEntryAuthorRole || (exports.LogEntryAuthorRole = LogEntryAuthorRole = {}));
exports.LogEntryAuthorRoleSchema = zod_1.z.nativeEnum(LogEntryAuthorRole);
var ConfigScope;
(function (ConfigScope) {
    ConfigScope[ConfigScope["Global"] = 100] = "Global";
    ConfigScope[ConfigScope["Organization"] = 200] = "Organization";
    ConfigScope[ConfigScope["Project"] = 300] = "Project";
})(ConfigScope || (exports.ConfigScope = ConfigScope = {}));
exports.ConfigScopeSchema = zod_1.z.nativeEnum(ConfigScope);
var FindingLinkOrigin;
(function (FindingLinkOrigin) {
    FindingLinkOrigin[FindingLinkOrigin["Direct"] = 100] = "Direct";
    FindingLinkOrigin[FindingLinkOrigin["Continuity"] = 200] = "Continuity";
})(FindingLinkOrigin || (exports.FindingLinkOrigin = FindingLinkOrigin = {}));
exports.FindingLinkOriginSchema = zod_1.z.nativeEnum(FindingLinkOrigin);
var FindingContinuityDisposition;
(function (FindingContinuityDisposition) {
    FindingContinuityDisposition["Reproduced"] = "reproduced";
    FindingContinuityDisposition["Resolved"] = "resolved";
})(FindingContinuityDisposition || (exports.FindingContinuityDisposition = FindingContinuityDisposition = {}));
exports.FindingContinuityDispositionSchema = zod_1.z.nativeEnum(FindingContinuityDisposition);
var AssertionDefinitionLifecycle;
(function (AssertionDefinitionLifecycle) {
    AssertionDefinitionLifecycle[AssertionDefinitionLifecycle["Draft"] = 100] = "Draft";
    AssertionDefinitionLifecycle[AssertionDefinitionLifecycle["Active"] = 200] = "Active";
    AssertionDefinitionLifecycle[AssertionDefinitionLifecycle["Retired"] = 300] = "Retired";
    AssertionDefinitionLifecycle[AssertionDefinitionLifecycle["Deleted"] = 400] = "Deleted";
})(AssertionDefinitionLifecycle || (exports.AssertionDefinitionLifecycle = AssertionDefinitionLifecycle = {}));
exports.AssertionDefinitionLifecycleSchema = zod_1.z.nativeEnum(AssertionDefinitionLifecycle);
//# sourceMappingURL=enums.js.map